import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';

export const EbookPopup = () => {
	const [isVisible, setIsVisible] = useState(false);
	const [email, setEmail] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [isDismissed, setIsDismissed] = useState(false);

	useEffect(() => {
		const dismissed = sessionStorage.getItem('ebook-popup-dismissed');
		if (dismissed) {
			setIsDismissed(true);
			return;
		}
		const timer = setTimeout(() => {
			setIsVisible(true);
		}, 4000);
		return () => clearTimeout(timer);
	}, []);

	const handleClose = () => {
		setIsVisible(false);
		setIsDismissed(true);
		sessionStorage.setItem('ebook-popup-dismissed', 'true');
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!email) return;

		setIsLoading(true);
		try {
			await emailjs.send(
				'service_id',
				'template_id',
				{ user_email: email },
				'user_id'
			);
			toast.success('Ebook został wysłany na Twój adres e-mail!');
			setEmail('');
			handleClose();
		} catch {
			toast.error('Wystąpił błąd. Spróbuj ponownie.');
		} finally {
			setIsLoading(false);
		}
	};

	if (isDismissed || !isVisible) return null;

	return (
		<div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 sm:p-6">
			<div
				className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm"
				onClick={handleClose}
			/>
			<div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in">
				<div className="bg-gradient-to-br from-primary-500 to-primary-700 px-8 pt-8 pb-10 text-white relative overflow-hidden">
					<div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
					<div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />
					<button
						onClick={handleClose}
						className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors duration-200"
					>
						<CloseIcon fontSize="small" className="text-white" />
					</button>
					<div className="relative">
						<div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mb-4">
							<AutoStoriesIcon sx={{ fontSize: 30 }} className="text-white" />
						</div>
						<h2 className="font-bold-custom text-2xl text-white mb-2">
							Bezpłatny eBook
						</h2>
						<p className="text-primary-100 font-montserrat-custom-medium text-sm leading-relaxed">
							Zapisz się i otrzymaj darmowy eBook z praktycznymi wskazówkami dla początkujących dotyczący treningu i zdrowego odżywiania.
						</p>
					</div>
				</div>

				<div className="px-8 py-7">
					<p className="text-gray-600 font-montserrat-custom-medium text-sm mb-5 leading-relaxed">
						Podaj swój adres e-mail, a wyślę Ci go zupełnie bezpłatnie.
					</p>
					<form onSubmit={handleSubmit} className="space-y-3">
						<div className="relative">
							<EmailIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" fontSize="small" />
							<input
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="Twój adres e-mail"
								required
								className="w-full pl-11 pr-4 py-3.5 border border-gray-200 rounded-2xl font-montserrat-custom-medium text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 transition-all duration-200"
							/>
						</div>
						<button
							type="submit"
							disabled={isLoading}
							className="w-full py-3.5 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-2xl shadow-soft hover:shadow-soft-lg hover:scale-[1.02] transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed font-montserrat-custom-medium"
						>
							{isLoading ? 'Wysyłanie...' : 'WYŚLIJ MI EBOOKA →'}
						</button>
						<button
							type="button"
							onClick={handleClose}
							className="w-full py-2 text-gray-400 text-sm font-montserrat-custom-medium hover:text-gray-600 transition-colors duration-200"
						>
							Nie, dziękuję
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};
